<template>
  <auth-summary @click="cancel">
    E-Mail-Adresse: <strong>{{ state.value.username }}</strong>
  </auth-summary>
</template>

<script>
import AuthSummary from "@/components/plenigo-auth/components/auth-summary";
export default {
  components: { AuthSummary },
  props: {
    state: Object
  },
  methods: {
    cancel() {
      this.$emit("update", "currentStep", "register");
      this.$emit("update", "value", undefined);
    }
  },
};
</script>
